import { Row, Col, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UNCHIN_SETTEI_TYPE } from 'src/constants/app';

type Props = {
  type: 'unexpired' | 'expired' | 'ordered';
  status?: string;
  unchinSettei: string;
};

const ItemLabel: React.FC<Props> = ({ type, status, unchinSettei }) => {
  const { t } = useTranslation();

  return (
    <Row className="item_label">
      <Col span={24}>
        <Typography.Title level={5} className="item_label_title">
          {type === 'unexpired'
            ? t('quotation_page.within_the_expiration_date')
            : type === 'expired'
            ? t('quotation_page.expired')
            : `${t('quotation_page.ordered')}${status ? `（${status}）` : ''}`}
        </Typography.Title>
        {type === 'ordered' && (
          <Typography.Text className="item_label_ordered_sub">
            {unchinSettei &&
              t(
                unchinSettei === UNCHIN_SETTEI_TYPE.EQUAL_TREATMENT
                  ? 'quotation_page.rebate_fare'
                  : 'quotation_page.total_fare',
              )}
          </Typography.Text>
        )}
      </Col>
    </Row>
  );
};

export default ItemLabel;
